import { render, staticRenderFns } from "./ModalNewBudget.vue?vue&type=template&id=18ae3dd8&scoped=true&"
import script from "./ModalNewBudget.vue?vue&type=script&lang=js&"
export * from "./ModalNewBudget.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewBudget.vue?vue&type=style&index=0&id=18ae3dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae3dd8",
  null
  
)

export default component.exports